import queryString from "query-string";
import services from "../../../../services";
import $ from 'jquery';

let data = [];

const generateId = data =>
    data.reduce((acc, current) => Math.max(acc, current.ProductID), 0) + 1;

export const insertItem = item => {
    item.ProductID = generateId(data);
    item.inEdit = false;
    item.IDAutoDetalhe = 0;
    item.Columns = [];
    data.unshift(item);
    return data;
};

export const deleteAll = () => {
    data = [];
    return data;

};
export const dataGet3 = async () => {
    return data;
};

export const getItems3 = async () =>  {
    console.log("services3")
    if(window.location.search != ""){
        var queryParams = queryString.parse(window.location.search)
        var  token = queryParams.idAuto
        var  dataToken = {"idAuto": token}
        var Detalhes = await services.apiCall.requestApi(
            "/Fiscalizacao/GetAutoDetalhe",
            dataToken,
            "get"
        ); 
        if($("#tipo_auto :selected").val() == "6" || $("#tipo_auto :selected").val() == "15"){
            for (let i = 0; i <Detalhes.autoGridViatura.length ; i++) {
                var Matricula = Detalhes.autoGridViatura[i].matricula;
                var DocumentoTransporte = Detalhes.autoGridViatura[i].documentoTransporte;
                var CertificadoProcedencia = Detalhes.autoGridViatura[i].certificadoProcedencia;
                var RCDO = Detalhes.autoGridViatura[i].rcdo;
                var VolumeViatura = Detalhes.autoGridViatura[i].volumeViatura;
                var SelosSegurancaSelagemViatura = Detalhes.autoGridViatura[i].selosSegurancaSelagemViatura;
                var EtiquetasSegurancaViatura = Detalhes.autoGridViatura[i].etiquetasSegurancaViatura;
                var SinetesViatura = Detalhes.autoGridViatura[i].sinetesViatura;
                var linha = Detalhes.autoGridViatura[i].linha;
                var selosSeguranca = [];
                var etiquetasViatura = []
                if(selosSeguranca.length == 0){
                    SelosSegurancaSelagemViatura.map((SelosSegurancaSelagemViatura) => (
                        selosSeguranca.push(SelosSegurancaSelagemViatura.idSelo)
                    
                    ));
                }
                if(etiquetasViatura.length == 0){
                    EtiquetasSegurancaViatura.map((EtiquetasSegurancaViatura) => (
                        etiquetasViatura.push(EtiquetasSegurancaViatura.idEtiqueta)
                    
                    ));
                }
                    data.push({ 
                        Matricula_viatura : Matricula,
                        Doc_Transporte_viatura : DocumentoTransporte,
                        Cert_precedencia_viatura : CertificadoProcedencia,
                        RCDO_viatura : RCDO,
                        Volume_viatura: VolumeViatura,
                        SelosSeguranca_viatura : selosSeguranca,
                        Etiquetas_selagem_viatura : etiquetasViatura,
                        Sinetes_viatura: SinetesViatura,
                        ProductID: linha,
                        IDAutoDetalhe: Detalhes.autoGridViatura[i].idAutoDetalhe,
                        Discontinued: false,
                        Columns: [],
                        inEdit: false
                    })
                    //// FIM selagem (grid1)
            }
            return data;
        }
    }else{
         return data
    }
    
};

export const updateItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data[index] = item;
    return data;
};

export const deleteItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data.splice(index, 1);
    return data;
};
